import { IGetMetadata } from '../types/metadata';
import useAnalyticsStore from '../store/analyticsStore';
import useDatasetStore from '../store/datasetStore';
import { usePointStore } from '../store/pointStore';
import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import { GLOBAL_HD_DTU_ID } from '../utils/common';
import { QUERY_KEYS } from './queryKeys';

export const useExtractionQuery = (
  datasetId: string,
  coordinates: number[],
  pointName: string,
  gridCellSize: string,
  waterDepth: string,
  timeStepInterval: string,
  metadata: IGetMetadata,
  enabled: boolean
) => {
  const enrichedMetadata = useAnalyticsStore((state) => state.enrichedMetadata);
  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);
  const fwePoints = usePointStore((state) => state.fwePoints);

  return useQuery({
    queryKey: [
      QUERY_KEYS.dataset.extraction,
      datasetId,
      coordinates,
      pointName,
      timeStepInterval,
    ],
    queryFn: async () => {
      if (metadata?.IsOffline || !metadata) {
        throw new Error('Invalid validation result');
      }

      const datasetTask = enrichedMetadata.find(
        (task: any) =>
          task.DatasetId === datasetId &&
          task.CoordinatesString === coordinates.join()
      );

      if (datasetTask) {
        return enrichedMetadata;
      }

      const createFullExtractionTasks =
        await Api.service.createFullExtractionTasks(
          [metadata],
          coordinates,
          pointName,
          gridCellSize,
          waterDepth,
          datasetBriefs,
          fwePoints,
          datasetId === GLOBAL_HD_DTU_ID ? parseInt(timeStepInterval) : 60
        );

      return enrichedMetadata.length === 0
        ? createFullExtractionTasks
        : enrichedMetadata.concat(createFullExtractionTasks);
    },
    enabled:
      !metadata?.IsOffline && !!datasetId && !!coordinates.length && enabled,
  });
};
